/* =============================================================
   PROTECKD — Gift with Purchase
   Single discount code: PROTECKD-GW10P
   ============================================================= */

(function () {

  var DISCOUNT = 'PROTECKD-GW10P';

  var CONFIG = {
    popupTitle: 'Pick 1 FREE Faraday Gift Today!',
    tiers: [
      {
        minSubtotal: 100,
        label: 'Free Faraday RFID Case (ALPHA TIER)',
        labelShort: 'RFID Case ($20)',
        products: [
          {
            title: 'Knight | RFID | Faraday Wallet',
            price: 20,
            image: 'https://cdn.shopify.com/s/files/1/0567/8805/8291/files/knight-rfid-faraday-oversized-wallet-e10-10-phone-case-one-size-black-cases-521.webp?v=1740517452',
            variants: [
              { id: 45410577875123, label: 'One Size / RFID / Black', image: 'https://www.proteckd.com/cdn/shop/files/knight-rfid-faraday-oversized-wallet-e10-10-phone-case-one-size-black-cases-521.webp?v=1740517452' }
            ]
          }
        ]
      },
      {
        minSubtotal: 250,
        label: 'Free Faraday Hat (BETA TEIR)',
        labelShort: 'Hat ($85)',
        products: [
          {
            title: 'Zephyr | Faraday Hat',
            price: 85,
            image: 'https://www.proteckd.com/cdn/shop/files/zephyr-faraday-silver-lined-emf-proof-hat-one-size-lining-carbon-black-hats-beanies-237.webp?v=1740517040',
            variants: [
              { id: 45410587541683, label: 'One Size / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/zephyr-faraday-silver-lined-emf-proof-hat-one-size-lining-carbon-black-hats-beanies-237.webp?v=1740517040' },
              { id: 45410587574451, label: 'One Size / Cosmic Cream', image: 'https://www.proteckd.com/cdn/shop/files/zephyr-faraday-silver-lined-emf-proof-hat-one-size-lining-techno-tan-hats-beanies-104.webp?v=1740517026' },
              { id: 45410587607219, label: 'One Size / Beautiful Blue', image: 'https://www.proteckd.com/cdn/shop/files/zephyr-faraday-silver-lined-emf-proof-hat-one-size-lining-beautiful-blue-hats-993.webp?v=1740517046' },
              { id: 45410587639987, label: 'One Size / Bionic Burgundy', image: 'https://www.proteckd.com/cdn/shop/files/faraday_hat_burgundy_1.jpg?v=1758639662' },
              { id: 45410587672755, label: 'One Size / Plasma Pink', image: 'https://www.proteckd.com/cdn/shop/files/zephyr-faraday-emf-protection-proof-hat-one-size-plasma-pink-hats-beanies-449.webp?v=1761849027' }
            ]
          },
          {
            title: 'Revolution | Faraday Beanie',
            price: 85,
            image: 'https://www.proteckd.com/cdn/shop/files/revolution-faraday-unisex-silver-lined-beanie-one-size-lining-carbon-black-hats-416.webp?v=1740517387',
            variants: [
              { id: 45410586165427, label: 'One Size / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/revolution-faraday-unisex-silver-lined-beanie-one-size-lining-carbon-black-hats-416.webp?v=1740517387' },
              { id: 45410586198195, label: 'One Size / Wistful White', image: 'https://www.proteckd.com/cdn/shop/files/revolution-faraday-unisex-silver-lined-beanie-one-size-lining-wistful-white-hats-868.webp?v=1740517398' },
              { id: 45410586230963, label: 'One Size / Slate Grey', image: 'https://www.proteckd.com/cdn/shop/files/revolution-faraday-unisex-silver-lined-beanie-one-size-lining-glitch-grey-hats-754.webp?v=1740517395' }
            ]
          },
          {
            title: 'Aviator | Faraday Slouch Beanie',
            price: 85,
            image: 'https://www.proteckd.com/cdn/shop/files/aviator-faraday-unisex-lightweight-silver-lined-slouch-beanie-large-lining-carbon-424.webp?v=1758227715',
            variants: [
              { id: 45410586820787, label: 'One Size / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aviator-faraday-unisex-lightweight-silver-lined-slouch-beanie-large-lining-carbon-424.webp?v=1758227715' },
              { id: 45410586853555, label: 'One Size / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aviator-faraday-unisex-lightweight-silver-lined-slouch-beanie-large-lining-glitch-694.webp?v=1740517535' },
              { id: 45410586919091, label: 'One Size / Techno Tan', image: 'https://www.proteckd.com/cdn/shop/files/aviator-faraday-unisex-lightweight-silver-lined-slouch-beanie-large-lining-techno-tan-592.webp?v=1758227715' },
              { id: 45410586951859, label: 'One Size / Galactic Green', image: 'https://www.proteckd.com/cdn/shop/files/aviator-faraday-unisex-lightweight-emf-protection-slouch-beanie-large-galactic-green-689.webp?v=1758228728' }
            ]
          }
        ]
      },
      {
        minSubtotal: 450,
        label: 'Free Faraday T-Shirt (DELTA TIER))',
        labelShort: 'Faraday Shirt ($150)',
        products: [
          {
            title: 'Stratos | Faraday Shirt',
            price: 150,
            image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027',
            variants: [
              { id: 45410588328115, label: '2XS / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410588360883, label: '2XS / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410588459187, label: 'XS / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410588491955, label: 'XS / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410588590259, label: 'S / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410588623027, label: 'S / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410588721331, label: 'M / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410588754099, label: 'M / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410588852403, label: 'L / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410588885171, label: 'L / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410588983475, label: 'XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410589016243, label: 'XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' },
              { id: 45410589114547, label: '2XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-regular-fit-emf-protection-shirt-2x-small-carbon-black-292.webp?v=1764728027' },
              { id: 45410589147315, label: '2XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/stratos-faraday-unisex-silver-lined-shirt-2x-small-lining-glitch-grey-genderless-649.webp?v=1740806427' }
            ]
          }
        ]
      },
      {
        minSubtotal: 850,
        label: 'Free Faraday Hoodie (OMEGA TIER)',
        labelShort: 'Hoodie ($250)',
        products: [
          {
            title: 'Aether Zip Up | Faraday Hoodie',
            price: 250,
            image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173',
            variants: [
              { id: 45410597863603, label: 'XS / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410597929139, label: 'XS / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' },
              { id: 45410598125747, label: 'S / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410598191283, label: 'S / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' },
              { id: 45410598387891, label: 'M / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410598453427, label: 'M / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' },
              { id: 45410598650035, label: 'L / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410598715571, label: 'L / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' },
              { id: 45410598912179, label: 'XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410598977715, label: 'XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' },
              { id: 45410599174323, label: '2XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-genderless-hoodies-871.webp?v=1740517173' },
              { id: 45410599239859, label: '2XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/aether-faraday-unisex-lightweight-silver-lined-zip-up-hoodie-x-small-lining-glitch-172.webp?v=1764952970' }
            ]
          },
          {
            title: 'Nebula Pullover | Faraday Hoodie',
            price: 250,
            image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378',
            variants: [
              { id: 45410591735987, label: 'XS / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410591768755, label: 'XS / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' },
              { id: 45410591998131, label: 'S / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410592030899, label: 'S / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' },
              { id: 45410592260275, label: 'M / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410592293043, label: 'M / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' },
              { id: 45410592522419, label: 'L / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410592555187, label: 'L / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' },
              { id: 45410592784563, label: 'XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410592817331, label: 'XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' },
              { id: 45410593046707, label: '2XL / Carbon Black', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-x-small-lining-carbon-black-837.webp?v=1759639378' },
              { id: 45410593079475, label: '2XL / Glitch Grey', image: 'https://www.proteckd.com/cdn/shop/files/nebula-faraday-unisex-lightweight-silver-lined-hoodie-genderless-hoodies-800.webp?v=1758157816' }
            ]
          }
        ]
      }
    ]
  };

  /* ============================================================
     SESSION STATE
  ============================================================ */

  function saveGift(g) { try { sessionStorage.setItem('gwp', JSON.stringify(g)); } catch(e){} }
  function loadGift() { try { var s = sessionStorage.getItem('gwp'); return s ? JSON.parse(s) : null; } catch(e){ return null; } }
  function clearGift() { try { sessionStorage.removeItem('gwp'); } catch(e){} }

  var currentGift = loadGift() || { ti: null, pi: null, variantId: null, lineKey: null };
  var overlay = null;
  var lastSubtotal = 0;
  var watcherRunning = false;
  var watcherBusy = false;

  /* ============================================================
     HELPERS
  ============================================================ */

  function getQualifiedTierIndex(subtotal) {
    var idx = null;
    CONFIG.tiers.forEach(function(t, i) { if (subtotal >= t.minSubtotal) idx = i; });
    return idx;
  }

  function getCartData(cb) {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(cb).catch(function() { cb(null); });
  }

  function syncGiftFromCart(cartItems) {
    var gwpInCart = null;
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].properties && cartItems[i].properties._gwp === 'true') {
        gwpInCart = cartItems[i];
        break;
      }
    }
    if (gwpInCart) {
      var ti = gwpInCart.properties._gwp_tier !== undefined ? parseInt(gwpInCart.properties._gwp_tier) : null;
      var pi = null;
      if (ti !== null && CONFIG.tiers[ti]) {
        CONFIG.tiers[ti].products.forEach(function(prod, idx) {
          prod.variants.forEach(function(v) {
            if (v.id === gwpInCart.variant_id) pi = idx;
          });
        });
      }
      if (currentGift.lineKey !== gwpInCart.key || currentGift.ti !== ti || currentGift.pi !== pi) {
        currentGift = { ti: ti, pi: pi, variantId: gwpInCart.variant_id, lineKey: gwpInCart.key };
        saveGift(currentGift);
      }
    } else {
      if (currentGift.lineKey) {
        clearGift();
        currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
      }
    }
  }

  /* ============================================================
     STYLES
  ============================================================ */

  var css = [
    '@keyframes gwp-line-in{0%{width:0}100%{width:var(--gwp-fill-w,0%)}}',
    '@keyframes gwp-fade-up{0%{opacity:0;transform:translateY(4px)}100%{opacity:1;transform:translateY(0)}}',
    '@keyframes gwp-hud-scan{0%{transform:translateY(-100%)}100%{transform:translateY(1500%)}}',
    '@keyframes gwp-hud-pulse{0%,100%{opacity:.45}50%{opacity:1}}',
    '@keyframes gwp-star-pulse{0%,100%{filter:drop-shadow(0 0 3px rgba(199,164,55,0.6))}50%{filter:drop-shadow(0 0 10px rgba(199,164,55,1))}}',
    '@keyframes gwp-holo-intro{0%{opacity:0;transform:scaleX(.04) scaleY(.02);filter:brightness(3) blur(4px);}12%{opacity:1;transform:scaleX(.5) scaleY(.02);filter:brightness(3) blur(3px);}24%{opacity:1;transform:scaleX(1) scaleY(.02);filter:brightness(3.2) blur(2.5px);}30%{opacity:.8;}35%{opacity:1;transform:scaleX(1) scaleY(.08);filter:brightness(2.6) blur(2px);}55%{opacity:1;transform:scaleX(1) scaleY(.45);filter:brightness(1.8) blur(1px);}72%{opacity:1;transform:scaleX(1) scaleY(1.04);filter:brightness(1.3) blur(0);}82%{opacity:.75;transform:scaleX(1) scaleY(.99);}90%{opacity:1;}95%{opacity:.9;}100%{opacity:1;transform:scaleX(1) scaleY(1);filter:brightness(1);}}',
    '@keyframes gwp-holo-scanline{0%{opacity:0;transform:translateY(-50%) scaleX(0);}15%{opacity:1;transform:translateY(-50%) scaleX(1);}85%{opacity:1;transform:translateY(1000%) scaleX(1);}100%{opacity:0;transform:translateY(1200%) scaleX(0);}}',
    '#gwp-bar{width:100%;padding:10px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;box-sizing:border-box;transform-origin:center center;animation:gwp-holo-intro 1.05s cubic-bezier(.2,.8,.2,1) forwards;position:relative;}',
    '#gwp-bar::after{content:"";position:absolute;left:0;right:0;top:50%;height:2px;background:linear-gradient(90deg,transparent,#00e5ff 20%,#fff 50%,#00e5ff 80%,transparent);box-shadow:0 0 14px #00e5ff,0 0 28px rgba(0,229,255,0.6);transform-origin:center center;animation:gwp-holo-scanline 1.05s cubic-bezier(.2,.8,.2,1) forwards;pointer-events:none;z-index:3;}',
    '#gwp-bar-inner{position:relative;border:1px solid rgba(0,229,255,0.55);box-shadow:0 0 22px rgba(0,229,255,0.22),inset 0 0 32px rgba(0,229,255,0.06);background:radial-gradient(ellipse 80% 140% at 50% 0%,rgba(0,229,255,0.14) 0%,transparent 60%),radial-gradient(ellipse 60% 100% at 50% 100%,rgba(0,229,255,0.08) 0%,transparent 70%),linear-gradient(135deg,rgba(10,15,26,0.62) 0%,rgba(6,12,24,0.75) 100%);backdrop-filter:blur(8px) saturate(1.2);-webkit-backdrop-filter:blur(8px) saturate(1.2);padding:18px 22px;clip-path:polygon(16px 0,100% 0,100% calc(100% - 16px),calc(100% - 16px) 100%,0 100%,0 16px);overflow:hidden;}',
    '#gwp-bar-inner::before{content:"";position:absolute;inset:0;pointer-events:none;z-index:0;background-image:linear-gradient(rgba(0,229,255,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(0,229,255,0.04) 1px,transparent 1px),radial-gradient(1px 1px at 12% 22%,rgba(255,255,255,0.4),transparent),radial-gradient(1px 1px at 78% 58%,rgba(0,229,255,0.6),transparent),radial-gradient(1px 1px at 40% 82%,rgba(255,255,255,0.28),transparent),radial-gradient(1px 1px at 62% 18%,rgba(0,229,255,0.4),transparent),radial-gradient(1px 1px at 88% 88%,rgba(255,255,255,0.35),transparent),radial-gradient(1px 1px at 24% 70%,rgba(0,229,255,0.4),transparent);background-size:32px 32px,32px 32px,100% 100%,100% 100%,100% 100%,100% 100%,100% 100%,100% 100%;}',
    '#gwp-bar-inner::after{content:"";position:absolute;left:0;right:0;height:2px;background:linear-gradient(90deg,transparent,rgba(0,229,255,0.5),transparent);animation:gwp-hud-scan 7s linear infinite;pointer-events:none;z-index:0;}',
    '.gwp-brk{position:absolute;width:14px;height:14px;pointer-events:none;z-index:2;border:1.5px solid #00e5ff;filter:drop-shadow(0 0 4px rgba(0,229,255,0.7));}',
    '.gwp-brk.tl{top:5px;left:5px;border-right:none;border-bottom:none;}',
    '.gwp-brk.tr{top:5px;right:5px;border-left:none;border-bottom:none;}',
    '.gwp-brk.bl{bottom:5px;left:5px;border-right:none;border-top:none;}',
    '.gwp-brk.br{bottom:5px;right:5px;border-left:none;border-top:none;}',
    '#gwp-bar-head{position:relative;z-index:1;margin-bottom:12px;}',
    '#gwp-bar-head .eyebrow{font-size:9px;letter-spacing:.26em;color:#00e5ff;font-weight:700;text-transform:uppercase;margin-bottom:4px;}',
    '#gwp-bar-head .title{display:flex;align-items:center;gap:9px;font-size:14px;letter-spacing:.14em;color:#fff;font-weight:800;text-transform:uppercase;}',
    '#gwp-bar-head .title::before{content:"";width:8px;height:8px;background:#00e5ff;border-radius:50%;box-shadow:0 0 10px #00e5ff;animation:gwp-hud-pulse 1.4s ease-in-out infinite;flex-shrink:0;}',
    '#gwp-bar-head .title .sep{opacity:.4;margin:0 2px;font-weight:400;}',
    '#gwp-bar-tier{color:#00e5ff;text-shadow:0 0 8px rgba(0,229,255,0.5);}',
    '#gwp-bar-tier.off{color:rgba(255,255,255,0.5);text-shadow:none;}',
    '#gwp-ship-strip{display:flex;align-items:center;gap:10px;padding:9px 0;border-top:1px dashed rgba(0,229,255,0.22);border-bottom:1px dashed rgba(0,229,255,0.22);position:relative;z-index:1;margin-bottom:12px;}',
    '#gwp-ship-strip .icon{width:22px;height:22px;display:flex;align-items:center;justify-content:center;background:rgba(0,229,255,0.1);border:1px solid rgba(0,229,255,0.42);clip-path:polygon(4px 0,100% 0,100% calc(100% - 4px),calc(100% - 4px) 100%,0 100%,0 4px);flex-shrink:0;}',
    '#gwp-cart-ship-msg{flex:1;color:rgba(255,255,255,0.85);font-size:11px;line-height:1.3;font-weight:600;}',
    '#gwp-cart-ship-msg span{color:#00e5ff;font-weight:800;}',
    '.gwp-ship-track{width:90px;height:4px;background:rgba(255,255,255,0.08);border-radius:99px;overflow:hidden;flex-shrink:0;}',
    '#gwp-cart-ship-fill{height:100%;width:0%;background:linear-gradient(90deg,#00e5ff 0%,#00ff88 100%);box-shadow:0 0 8px rgba(0,229,255,0.6);transition:width 0.6s cubic-bezier(0.22,1,0.36,1);}',
    '#gwp-cart-ship-region{background:rgba(0,0,0,0.45);border:1px solid rgba(0,229,255,0.42);color:#00e5ff;font-family:inherit;font-size:9px;font-weight:700;padding:3px 7px;cursor:pointer;outline:none;letter-spacing:.1em;flex-shrink:0;}',
    '#gwp-progress-wrap{position:relative;z-index:1;margin-bottom:14px;animation:gwp-fade-up 0.45s 0.15s ease both;}',
    '#gwp-bar-msg{font-size:11px;letter-spacing:.16em;color:#c7a437;font-weight:800;text-transform:uppercase;margin-bottom:7px;line-height:1.3;}',
    '#gwp-bar-msg span{color:#ffc864;font-weight:800;}',
    '#gwp-bar-msg.unlocked{color:#4dffa8;}',
    '#gwp-bar-msg.unlocked span{color:#4dffa8;}',
    '#gwp-bar-track{height:3px;background:rgba(255,255,255,0.07);border-radius:99px;overflow:hidden;}',
    '#gwp-bar-fill{height:100%;width:0%;background:linear-gradient(90deg,#c7a437 0%,#ffc864 100%);box-shadow:0 0 8px rgba(199,164,55,0.6);border-radius:99px;transition:width 0.8s cubic-bezier(0.22,1,0.36,1);}',
    '#gwp-bar-fill.unlocked{background:linear-gradient(90deg,#00e5ff 0%,#00ff88 100%);box-shadow:0 0 8px rgba(0,229,255,0.6);}',
    '.gwp-select-lbl{display:flex;align-items:center;gap:8px;font-size:11px;letter-spacing:.2em;color:#ffc864;font-weight:800;text-transform:uppercase;margin-bottom:10px;position:relative;z-index:1;}',
    '.gwp-select-lbl::before{content:"\\2605";font-size:14px;color:#c7a437;animation:gwp-star-pulse 1.8s ease-in-out infinite;}',
    '.gwp-gift-sections{display:flex;gap:12px;position:relative;z-index:1;overflow-x:auto;overflow-y:hidden;padding:2px 2px 6px;animation:gwp-fade-up 0.5s 0.25s ease both;min-width:0;}',
    '.gwp-gift-sections::-webkit-scrollbar{height:6px;}',
    '.gwp-gift-sections::-webkit-scrollbar-track{background:rgba(0,229,255,0.05);}',
    '.gwp-gift-sections::-webkit-scrollbar-thumb{background:rgba(0,229,255,0.4);border-radius:99px;}',
    '.gwp-tier-group{border:1px solid rgba(0,229,255,0.25);background:rgba(0,229,255,0.03);padding:10px 12px 12px;clip-path:polygon(10px 0,100% 0,100% calc(100% - 10px),calc(100% - 10px) 100%,0 100%,0 10px);flex:1 1 0;min-width:150px;}',
    '.gwp-tier-group.is-locked{border-color:rgba(255,255,255,0.12);background:rgba(255,255,255,0.02);}',
    '.gwp-tier-head{display:inline-flex;align-items:center;gap:6px;font-size:10px;letter-spacing:.16em;color:#00e5ff;font-weight:800;text-transform:uppercase;padding:4px 10px;background:rgba(0,229,255,0.1);border:1px solid rgba(0,229,255,0.35);margin-bottom:10px;clip-path:polygon(5px 0,100% 0,calc(100% - 5px) 100%,0 100%);white-space:nowrap;}',
    '.gwp-tier-head::before{content:"";width:8px;height:8px;background:#00e5ff;transform:rotate(45deg);box-shadow:0 0 6px rgba(0,229,255,0.7);flex-shrink:0;}',
    '.gwp-tier-group.is-locked .gwp-tier-head{color:rgba(255,255,255,0.55);background:rgba(255,255,255,0.04);border-color:rgba(255,255,255,0.18);}',
    '.gwp-tier-group.is-locked .gwp-tier-head::before{background:rgba(255,255,255,0.3);box-shadow:none;}',
    '.gwp-tier-head .lock{color:#ff9b60;margin-left:4px;letter-spacing:.1em;}',
    '.gwp-tier-items{display:flex;gap:8px;}',
    '.gwp-gift-card{position:relative;flex:1 1 0;min-width:0;max-width:200px;background:rgba(0,0,0,0.3);border:1px solid rgba(0,229,255,0.28);padding:8px 8px 10px;cursor:pointer;transition:all 0.2s;clip-path:polygon(6px 0,100% 0,100% calc(100% - 6px),calc(100% - 6px) 100%,0 100%,0 6px);text-align:center;outline:none;}',
    '.gwp-gift-card:hover,.gwp-gift-card:focus-visible{border-color:#00e5ff;background:rgba(0,229,255,0.08);transform:translateY(-2px);box-shadow:0 4px 14px rgba(0,229,255,0.25);}',
    '.gwp-gift-card.picked{border-color:#00ff88;background:rgba(0,255,136,0.08);box-shadow:0 0 14px rgba(0,255,136,0.3),inset 0 0 12px rgba(0,255,136,0.06);}',
    '.gwp-gift-card.picked::after{content:"\\2713";position:absolute;top:5px;right:5px;width:16px;height:16px;background:#00ff88;color:#0a0f1a;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:900;border-radius:2px;z-index:2;}',
    '.gwp-gift-card .img-wrap{position:relative;width:100%;aspect-ratio:1/1;margin-bottom:7px;background:rgba(0,229,255,0.04);border:1px solid rgba(0,229,255,0.15);overflow:hidden;}',
    '.gwp-gift-card .img-wrap img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.gwp-gift-card .name{font-size:11px;color:#fff;font-weight:700;line-height:1.2;margin-bottom:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.gwp-gift-card .price{font-size:10px;letter-spacing:.06em;color:#00e5ff;font-weight:800;text-transform:uppercase;}',
    '.gwp-gift-card .price s{color:rgba(255,255,255,0.45);font-weight:400;margin-left:3px;}',
    '.gwp-tier-group.is-locked .gwp-gift-card{opacity:0.55;cursor:not-allowed;filter:grayscale(0.5);border-color:rgba(255,255,255,0.12);}',
    '.gwp-tier-group.is-locked .gwp-gift-card:hover{transform:none;border-color:rgba(255,255,255,0.12);background:rgba(0,0,0,0.3);box-shadow:none;}',
    '.gwp-tier-group.is-locked .gwp-gift-card .price{color:rgba(255,255,255,0.55);}',
    '.gwp-gift-card.shake{animation:gwp-locked-shake 0.42s cubic-bezier(.36,.07,.19,.97) both;}',
    '@keyframes gwp-locked-shake{10%,90%{transform:translateX(-1px);}20%,80%{transform:translateX(2px);}30%,50%,70%{transform:translateX(-3px);}40%,60%{transform:translateX(3px);}}',
    '.gwp-locked-toast{position:fixed;transform:translate(-50%,-100%) translateY(4px);background:rgba(10,15,26,0.97);border:1px solid #ff9b60;color:#ffd5a8;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:800;padding:7px 12px;white-space:nowrap;clip-path:polygon(5px 0,100% 0,100% calc(100% - 5px),calc(100% - 5px) 100%,0 100%,0 5px);box-shadow:0 4px 18px rgba(255,155,96,0.4),0 0 14px rgba(255,155,96,0.3);opacity:0;pointer-events:none;z-index:2147483646;transition:opacity .18s ease,transform .18s ease;}',
    '.gwp-locked-toast.show{opacity:1;transform:translate(-50%,-100%) translateY(-4px);}',
    '.gwp-locked-toast::after{content:"";position:absolute;top:100%;left:50%;transform:translateX(-50%);border:6px solid transparent;border-top-color:#ff9b60;filter:drop-shadow(0 2px 4px rgba(255,155,96,0.3));}',
    '.gwp-locked-toast b{color:#ffb37a;font-weight:900;}',
    '@media(max-width:700px){',
    '  #gwp-bar{padding:8px;}',
    '  #gwp-bar-inner{padding:14px 16px;clip-path:polygon(12px 0,100% 0,100% calc(100% - 12px),calc(100% - 12px) 100%,0 100%,0 12px);}',
    '  #gwp-bar-head .title{font-size:12px;letter-spacing:.1em;}',
    '  #gwp-bar-head .eyebrow{font-size:8px;letter-spacing:.2em;}',
    '  #gwp-ship-strip{gap:8px;flex-wrap:wrap;}',
    '  #gwp-cart-ship-msg{font-size:10px;}',
    '  .gwp-ship-track{width:60px;}',
    '  #gwp-bar-msg{font-size:10px;letter-spacing:.12em;}',
    '  .gwp-select-lbl{font-size:10px;letter-spacing:.14em;}',
    '  .gwp-tier-head{font-size:9px;padding:3px 8px;letter-spacing:.12em;}',
    '  .gwp-tier-group{padding:8px 10px 10px;flex:0 0 auto;min-width:0;}',
    '  .gwp-gift-card{flex:0 0 92px;max-width:92px;padding:6px 6px 8px;}',
    '  .gwp-gift-card .name{font-size:10px;}',
    '  .gwp-gift-card .price{font-size:9px;}',
    '}',
    '@media(max-width:420px){',
    '  #gwp-bar-head .title{font-size:11px;letter-spacing:.08em;gap:6px;}',
    '  .gwp-brk{width:10px;height:10px;}',
    '  .gwp-gift-card{flex-basis:80px;max-width:80px;}',
    '}',
    '#gwp-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,0.88);z-index:2147483647;align-items:center;justify-content:center;}',
    '#gwp-overlay.open{display:flex;}',
    '#gwp-modal{background:rgba(10,15,26,0.72);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border:2px solid rgba(0,229,255,0.85);border-radius:4px;width:92%;max-width:500px;max-height:88vh;overflow-y:auto;position:relative;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#fff;box-shadow:0 0 60px rgba(0,229,255,0.35),0 0 20px rgba(0,229,255,0.2);}',
    '#gwp-modal::-webkit-scrollbar{width:4px;}',
    '#gwp-modal::-webkit-scrollbar-thumb{background:#00e5ff33;border-radius:2px;}',
    '#gwp-mclose{position:absolute;top:12px;right:14px;width:28px;height:28px;border-radius:2px;background:transparent;color:#00e5ff;border:1px solid #00e5ff33;font-size:18px;cursor:pointer;line-height:28px;text-align:center;padding:0;z-index:1;}',
    '#gwp-mclose:hover{background:#00e5ff22;}',
    '#gwp-mhdr{padding:22px 20px 14px;border-bottom:1px solid #00e5ff1a;text-align:center;}',
    '#gwp-eyebrow{font-size:10px;letter-spacing:0.15em;color:#00e5ff;text-transform:uppercase;margin-bottom:6px;}',
    '#gwp-mtitle{font-size:17px;font-weight:700;color:#fff;line-height:1.3;}',
    '.gwp-tsec{border-bottom:1px solid #ffffff0d;}',
    '.gwp-thdr{display:flex;align-items:center;padding:12px 18px;gap:10px;transition:background 0.15s;}',
    '.gwp-thdr.clickable{cursor:pointer;}',
    '.gwp-thdr.clickable:hover{background:#ffffff06;border-left:2px solid rgba(0,229,255,0.5);}',
    '.gwp-thdr.locked{opacity:0.5;cursor:default;border-left:2px solid rgba(255,68,68,0.4);}',
    '.gwp-tdot{width:10px;height:10px;border-radius:50%;border:1.5px solid #333;flex-shrink:0;transition:all 0.2s;}',
    '.gwp-tdot.on{border-color:#00e5ff;background:#00e5ff;box-shadow:0 0 5px #00e5ff77;}',
'.gwp-tlbl{flex:1;font-size:13px;font-weight:500;color:rgba(255,255,255,0.85);line-height:1.3;}',
    '.gwp-tlbl.on{color:#fff;}',
    '.gwp-tinfo{font-size:10px;white-space:nowrap;flex-shrink:0;}',
    '.gwp-tinfo.sel{color:#00e5ff;font-weight:700;}',
'.gwp-tinfo.lock{color:#ff6b6b;font-weight:600;}',
'.gwp-tchv{font-size:9px;color:rgba(255, 255, 255, 0.77);transition:transform 0.2s;flex-shrink:0;}',    '.gwp-thdr.open .gwp-tchv{transform:rotate(180deg);}',
    '.gwp-tbody{display:none;padding:0 14px 12px;}',
    '.gwp-tbody.open{display:block;}',
'.gwp-prod{display:flex;align-items:center;gap:12px;padding:12px;border:1.5px solid rgba(0,229,255,0.22);margin-bottom:8px;position:relative;background:rgba(0,229,255,0.03);transition:border-color .15s,background .15s,transform .15s,box-shadow .15s;clip-path:polygon(0% 0%,calc(100% - 10px) 0%,100% 10px,100% 100%,10px 100%,0% calc(100% - 10px));cursor:pointer;outline:none;}',
'.gwp-prod:hover,.gwp-prod:focus-visible{border-color:rgba(0,229,255,0.65);background:rgba(0,229,255,0.07);transform:translateY(-1px);box-shadow:0 4px 12px rgba(0,229,255,0.12);}',
'.gwp-prod.picked{border-color:#00e5ff;background:rgba(0,229,255,0.1);box-shadow:0 0 14px rgba(0,229,255,0.25),inset 0 0 10px rgba(0,229,255,0.05);}',
'.gwp-prod img{width:64px;height:64px;object-fit:cover;flex-shrink:0;background:#111;border:1px solid rgba(0,229,255,0.3);}',
'.gwp-pchk{display:none;}',
'.gwp-pinfo{flex:1;min-width:0;}',
'.gwp-pname{font-size:13px;font-weight:600;margin-bottom:4px;line-height:1.3;color:#fff;}',
'.gwp-pprice{font-size:12px;font-weight:700;color:#00e5ff;letter-spacing:.02em;}',
'.gwp-pprice s{font-weight:400;margin-left:4px;}',
'.gwp-popup-track{position:relative;margin:20px 40px 72px;}',
'.gwp-pchev{font-size:10px;color:#00e5ff;font-weight:700;letter-spacing:.12em;text-transform:uppercase;line-height:1;flex-shrink:0;padding:8px 11px;border:1px solid rgba(0,229,255,0.45);background:rgba(0,229,255,0.05);transition:all .15s;white-space:nowrap;clip-path:polygon(4px 0,100% 0,100% calc(100% - 4px),calc(100% - 4px) 100%,0 100%,0 4px);}',
'.gwp-prod:hover .gwp-pchev,.gwp-prod:focus-visible .gwp-pchev{background:rgba(0,229,255,0.18);border-color:#00e5ff;color:#fff;box-shadow:0 0 10px rgba(0,229,255,0.4);}',
'.gwp-prod.picked .gwp-pchev{background:#00e5ff;color:#0a0f1a;border-color:#00e5ff;box-shadow:0 0 12px rgba(0,229,255,0.6);}',
'#gwp-instr{padding:10px 18px;text-align:center;font-size:10px;letter-spacing:.22em;color:#00e5ff;text-transform:uppercase;font-weight:700;background:rgba(0,229,255,0.06);border-bottom:1px solid rgba(0,229,255,0.18);}',
'#gwp-mfooter{padding:12px 18px;border-top:1px solid #00e5ff1a;}',
'#gwp-cont{width:100%;padding:12px;background:#00e5ff;color:#000;border:none;border-radius:2px;font-size:13px;font-weight:800;cursor:pointer;letter-spacing:0.08em;text-transform:uppercase;transition:all 0.15s;box-shadow:0 0 18px rgba(0,229,255,0.5),0 0 40px rgba(0,229,255,0.2);}',
'#gwp-cont:hover{background:#33ecff;box-shadow:0 0 28px rgba(0,229,255,0.8),0 0 60px rgba(0,229,255,0.35);}',
'#gwp-cont:disabled{background:#1a2535;color:rgba(255,255,255,0.45);cursor:not-allowed;box-shadow:none;letter-spacing:0.08em;}',
'@media (max-width:600px){',
'  #gwp-overlay{align-items:stretch;justify-content:stretch;background:rgba(10,15,26,.96);}',
'  #gwp-modal{width:100%;max-width:none;height:100vh;height:100dvh;max-height:none;border-radius:0;border-left:none;border-right:none;border-top:none;clip-path:none;}',
'  #gwp-mhdr{padding:18px 14px 12px;}',
'  .gwp-popup-track{margin:14px 24px 56px;}',
'  #gwp-mtitle{font-size:15px;}',
'  #gwp-eyebrow{font-size:9px;}',
'  .gwp-thdr{padding:11px 14px;gap:8px;}',
'  .gwp-tlbl{font-size:12px;}',
'  .gwp-tinfo{font-size:9px;}',
'  .gwp-tbody{padding:0 10px 10px;}',
'  .gwp-prod{padding:10px;gap:10px;}',
'  .gwp-prod img{width:56px;height:56px;}',
'  .gwp-pname{font-size:13px;}',
'  .gwp-pprice{font-size:12px;}',
'  .gwp-pchev{font-size:8px;padding:6px 8px;letter-spacing:.06em;}',
'  #gwp-instr{padding:9px 14px;font-size:9px;letter-spacing:.18em;}',
'}',
'@media (max-width:420px){',
'  .gwp-pchev span{display:none;}',
'  .gwp-pchev{font-size:16px;padding:6px 10px;line-height:1;letter-spacing:0;}',
'  #gwp-mfooter{padding:12px 14px calc(14px + env(safe-area-inset-bottom, 0px));}',
'  #gwp-cont{padding:14px;font-size:12px;}',
'}',
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  /* ============================================================
     PROGRESS BAR
  ============================================================ */

  var SHIP_THRESHOLDS = { us: 99, intl: 199 };

  function updateCartShipBar(subtotal) {
    var fillEl = document.getElementById('gwp-cart-ship-fill');
    var msgEl = document.getElementById('gwp-cart-ship-msg');
    var regionEl = document.getElementById('gwp-cart-ship-region');
    if (!fillEl || !regionEl) return;
    var region = regionEl.value;
    var threshold = SHIP_THRESHOLDS[region];
    var pct = Math.min((subtotal / threshold) * 100, 100);
    fillEl.style.width = pct + '%';
    if (subtotal >= threshold) {
      msgEl.innerHTML = '<span style="color:#00ff88;font-weight:700;">✓ You unlocked FREE shipping!</span>';
    } else {
      var needed = (threshold - subtotal).toFixed(2);
      var label = region === 'us' ? 'US' : 'International';
      msgEl.innerHTML = 'Add <span style="color:#00e5ff;font-weight:700;">$' + needed + '</span> for FREE ' + label + ' shipping';
    }
  }

  function initCartShipBar() {
    var regionEl = document.getElementById('gwp-cart-ship-region');
    if (!regionEl || regionEl._gwpInit) return;
    regionEl._gwpInit = true;
    var savedRegion = (typeof localStorage !== 'undefined' ? localStorage.getItem('gwp-ship-region') : null) ||
      ((typeof Shopify !== 'undefined' && Shopify.country && Shopify.country !== 'US') ? 'intl' : 'us');
    regionEl.value = savedRegion;
    regionEl.addEventListener('change', function() {
      try { localStorage.setItem('gwp-ship-region', regionEl.value); } catch(e){}
      updateCartShipBar(lastSubtotal);
      // Also update popup ship bar if open
      var popupRegion = document.getElementById('gwp-ship-region');
      if (popupRegion) { popupRegion.value = regionEl.value; if (window.gwpUpdateShipBar) window.gwpUpdateShipBar(lastSubtotal); }
    });
  }

  function updateBar(subtotal) {
    lastSubtotal = subtotal;
    var qualIdx = getQualifiedTierIndex(subtotal);
    initCartShipBar();
    updateCartShipBar(subtotal);
    var maxMin = CONFIG.tiers[CONFIG.tiers.length - 1].minSubtotal;
    var fill = document.getElementById('gwp-bar-fill');
    var msg = document.getElementById('gwp-bar-msg');

    if (fill) {
      var pct = Math.min(100, (subtotal / maxMin) * 100) + '%';
      fill.style.width = pct;
      fill.style.setProperty('--gwp-fill-w', pct);
      if (qualIdx !== null) fill.classList.add('unlocked');
      else fill.classList.remove('unlocked');
    }

    if (msg) {
      msg.classList.remove('unlocked');
      if (qualIdx === CONFIG.tiers.length - 1) {
        msg.classList.add('unlocked');
        msg.innerHTML = '\u2713 Max Tier Unlocked \u00b7 Pick Your Free Gift';
      } else {
        var next = CONFIG.tiers[qualIdx !== null ? qualIdx + 1 : 0];
        var needed = Math.ceil(next.minSubtotal - subtotal);
        var nextShort = ((next.labelShort || '').split(' (')[0]).toUpperCase();
        if (qualIdx !== null) {
          msg.classList.add('unlocked');
          msg.innerHTML = '\u2713 Gift Unlocked \u00b7 <span>$' + needed + '.00</span> from ' + nextShort;
        } else {
          msg.innerHTML = '<span>$' + needed + '.00</span> from ' + nextShort;
        }
      }
    }

    var tierChip = document.getElementById('gwp-bar-tier');
    if (tierChip) {
      if (qualIdx !== null) {
        var tierLbl = CONFIG.tiers[qualIdx].label;
        var m = tierLbl.match(/\(([A-Z]+)\s*T[EI]ER\)?\)?/i);
        tierChip.textContent = (m ? m[1] : 'Tier ' + (qualIdx + 1)) + ' Unlocked';
        tierChip.classList.remove('off');
      } else {
        tierChip.textContent = 'Standby';
        tierChip.classList.add('off');
      }
    }

    CONFIG.tiers.forEach(function(tier, ti) {
      var group = document.querySelector('[data-tier-group="' + ti + '"]');
      if (!group) return;
      var reached = subtotal >= tier.minSubtotal;
      var headLock = group.querySelector('.gwp-tier-head .lock');
      if (reached) {
        group.classList.remove('is-locked');
        if (headLock) headLock.textContent = '';
      } else {
        group.classList.add('is-locked');
        if (headLock) {
          var need = Math.ceil(tier.minSubtotal - subtotal);
          headLock.textContent = '\u00b7 +$' + need;
        }
      }
      tier.products.forEach(function(prod, pi) {
        var card = group.querySelector('.gwp-gift-card[data-ti="' + ti + '"][data-pi="' + pi + '"]');
        if (!card) return;
        if (currentGift.ti === ti && currentGift.pi === pi) card.classList.add('picked');
        else card.classList.remove('picked');
      });
    });
  }

  function showLockedToast(card, tier) {
    if (!card) return;
    var need = Math.max(0, Math.ceil(tier.minSubtotal - lastSubtotal));

    var prev = document.getElementById('gwp-locked-toast-active');
    if (prev) {
      if (prev._hideTimer) clearTimeout(prev._hideTimer);
      if (prev._removeTimer) clearTimeout(prev._removeTimer);
      prev.remove();
    }
    if (card._gwpShakeTimer) clearTimeout(card._gwpShakeTimer);

    var rect = card.getBoundingClientRect();
    var toast = document.createElement('div');
    toast.id = 'gwp-locked-toast-active';
    toast.className = 'gwp-locked-toast';
    toast.innerHTML = need > 0
      ? 'Add <b>$' + need + '</b> more to unlock'
      : 'Tier locked';
    toast.style.left = (rect.left + rect.width / 2) + 'px';
    toast.style.top = rect.top + 'px';
    document.body.appendChild(toast);
    requestAnimationFrame(function() { toast.classList.add('show'); });

    card.classList.remove('shake');
    void card.offsetWidth;
    card.classList.add('shake');
    card._gwpShakeTimer = setTimeout(function() { card.classList.remove('shake'); }, 500);

    toast._hideTimer = setTimeout(function() {
      toast.classList.remove('show');
      toast._removeTimer = setTimeout(function() {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 220);
    }, 2200);
  }

  function buildProgressBar(subtotal) {
    if (document.getElementById('gwp-bar')) { updateBar(subtotal); return; }

    var bar = document.createElement('div');
    bar.id = 'gwp-bar';

    var sectionsHtml = '';
    CONFIG.tiers.forEach(function(tier, ti) {
      var cardsHtml = '';
      tier.products.forEach(function(prod, pi) {
        var firstVar = prod.variants[0];
        var imgSrc = (firstVar && firstVar.image) ? firstVar.image : prod.image;
        var shortName = (prod.title || '').split(' |')[0].trim();
        var safeTitle = (prod.title || '').replace(/"/g, '&quot;');
        cardsHtml +=
          '<div class="gwp-gift-card" data-ti="' + ti + '" data-pi="' + pi + '" role="button" tabindex="0" title="' + safeTitle + '">' +
            '<div class="img-wrap"><img src="' + imgSrc + '" alt="' + safeTitle + '" loading="lazy"></div>' +
            '<div class="name">' + shortName + '</div>' +
            '<div class="price">Free <s>$' + prod.price + '</s></div>' +
          '</div>';
      });
      sectionsHtml +=
        '<div class="gwp-tier-group" data-tier-group="' + ti + '" style="flex-grow:' + tier.products.length + ';">' +
          '<div class="gwp-tier-head">Tier ' + (ti + 1) + ' \u00b7 $' + tier.minSubtotal + '+<span class="lock"></span></div>' +
          '<div class="gwp-tier-items">' + cardsHtml + '</div>' +
        '</div>';
    });

    bar.innerHTML =
      '<div id="gwp-bar-inner">' +
        '<span class="gwp-brk tl"></span><span class="gwp-brk tr"></span>' +
        '<span class="gwp-brk bl"></span><span class="gwp-brk br"></span>' +
        '<div id="gwp-bar-head">' +
          '<div class="eyebrow">\u25b8 Signal Active</div>' +
          '<div class="title">Faraday Rewards<span class="sep">//</span><span id="gwp-bar-tier" class="off">Standby</span></div>' +
        '</div>' +
        '<div id="gwp-ship-strip">' +
          '<div class="icon"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#00e5ff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></div>' +
          '<div id="gwp-cart-ship-msg">Loading...</div>' +
          '<div class="gwp-ship-track"><div id="gwp-cart-ship-fill"></div></div>' +
          '<select id="gwp-cart-ship-region"><option value="us">US</option><option value="intl">INTL</option></select>' +
        '</div>' +
        '<div id="gwp-progress-wrap">' +
          '<div id="gwp-bar-msg">Loading...</div>' +
          '<div id="gwp-bar-track"><div id="gwp-bar-fill"></div></div>' +
        '</div>' +
        '<div class="gwp-select-lbl">Select 1 Free Product</div>' +
        '<div class="gwp-gift-sections">' + sectionsHtml + '</div>' +
      '</div>';

    bar.querySelectorAll('.gwp-gift-card').forEach(function(card) {
      var ti = parseInt(card.getAttribute('data-ti'));
      var pi = parseInt(card.getAttribute('data-pi'));
      var handler = function(e) {
        e.stopPropagation();
        var group = card.closest('.gwp-tier-group');
        var tier = CONFIG.tiers[ti];
        if (group && group.classList.contains('is-locked')) {
          showLockedToast(card, tier);
          return;
        }
        var prod = tier.products[pi];
        openProductHolo(prod, tier, ti, pi);
      };
      card.addEventListener('click', handler);
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handler(e); }
      });
    });

    var cartMain = document.querySelector('main') ||
                   document.querySelector('.cart-page') ||
                   document.querySelector('[data-section-type="cart-template"]') ||
                   document.querySelector('.page-container') ||
                   document.body;
    cartMain.insertBefore(bar, cartMain.firstChild);

    updateBar(subtotal);
  }

  /* ============================================================
     POPUP
  ============================================================ */

  function buildPopup() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.id = 'gwp-overlay';
    var modal = document.createElement('div');
    modal.id = 'gwp-modal';

    var closeBtn = document.createElement('button');
    closeBtn.id = 'gwp-mclose';
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closePopup);

var mhdr = document.createElement('div');
mhdr.id = 'gwp-mhdr';
mhdr.innerHTML = '<div id="gwp-eyebrow">// Faraday Protection Reward</div><div id="gwp-mtitle">' + CONFIG.popupTitle + '</div>';

var popupTrackWrap = document.createElement('div');
popupTrackWrap.className = 'gwp-popup-track';

var popupTrack = document.createElement('div');
popupTrack.style.cssText = 'height:2px;background:rgba(255,255,255,0.07);border-radius:2px;';

var popupFill = document.createElement('div');
popupFill.id = 'gwp-popup-fill';
popupFill.style.cssText = 'height:100%;background:#00e5ff;border-radius:2px;box-shadow:0 0 8px rgba(0,229,255,0.6);width:0%;transition:width 0.8s cubic-bezier(0.22,1,0.36,1);';
popupTrack.appendChild(popupFill);
popupTrackWrap.appendChild(popupTrack);

var popupMsg = document.createElement('div');
popupMsg.id = 'gwp-popup-msg';
popupMsg.style.cssText = 'text-align:center;font-size:14px;font-weight:700;color:#fff;margin:0 0 8px;line-height:1.5;';

var maxMin = CONFIG.tiers[CONFIG.tiers.length - 1].minSubtotal;
CONFIG.tiers.forEach(function(tier, ti) {
var pct = Math.min((tier.minSubtotal / maxMin) * 100, 94);
  var mile = document.createElement('div');
  mile.style.cssText = 'position:absolute;top:-13px;left:' + pct + '%;transform:translateX(-50%);display:flex;flex-direction:column;align-items:center;';
  mile.setAttribute('data-popup-ti', ti);
  mile.innerHTML = '<div class="gwp-mile-dot"><svg viewBox="0 0 28 28" width="22" height="22"><polygon class="outer" points="14,1 27,14 14,27 1,14"/><polygon class="inner" points="14,6 22,14 14,22 6,14"/></svg></div>' +
'<div style="position:absolute;top:26px;width:68px;text-align:center;font-size:9px;font-weight:700;letter-spacing:0.03em;line-height:1.3;color:rgba(255,255,255,0.7);">' + tier.labelShort.split(' (')[0] + '<span style="display:block;font-weight:400;font-size:8px;color:rgba(255,255,255,0.5);">(' + (tier.labelShort.split(' (')[1] || '') + '</span></div>';
  popupTrackWrap.appendChild(mile);
});

mhdr.appendChild(popupMsg);
mhdr.appendChild(popupTrackWrap);
modal.appendChild(closeBtn);
modal.appendChild(mhdr);

var instr = document.createElement('div');
instr.id = 'gwp-instr';
instr.innerHTML = '\u25b8 Pick One Gift Below';
modal.appendChild(instr);

window.gwpUpdateShipBar = window.gwpUpdateShipBar || function() {};

    CONFIG.tiers.forEach(function(tier, ti) {
      var sec = document.createElement('div');
      sec.className = 'gwp-tsec';

      var thdr = document.createElement('div');
      thdr.className = 'gwp-thdr';
      thdr.id = 'gwp-thdr-' + ti;

      var tdot = document.createElement('div');
      tdot.className = 'gwp-tdot';
      tdot.id = 'gwp-tdot-' + ti;

      var tlbl = document.createElement('div');
      tlbl.className = 'gwp-tlbl';
      tlbl.textContent = tier.label;

      var tinfo = document.createElement('div');
      tinfo.className = 'gwp-tinfo';
      tinfo.id = 'gwp-tinfo-' + ti;

      var tchv = document.createElement('div');
      tchv.className = 'gwp-tchv';
      tchv.innerHTML = '&#9660;';

      thdr.appendChild(tdot);
      thdr.appendChild(tlbl);
      thdr.appendChild(tinfo);
      thdr.appendChild(tchv);

      var tbody = document.createElement('div');
      tbody.className = 'gwp-tbody';
      tbody.id = 'gwp-tbody-' + ti;

      tier.products.forEach(function(prod, pi) {
        var card = document.createElement('div');
        card.className = 'gwp-prod';
        card.id = 'gwp-prod-' + ti + '-' + pi;

        var pchk = document.createElement('div');
        pchk.className = 'gwp-pchk';
        pchk.innerHTML = '<svg viewBox="0 0 12 12" fill="none"><polyline points="2,6 5,9 10,3" stroke="#000" stroke-width="2.5" stroke-linecap="round"/></svg>';

        var img = document.createElement('img');
        img.src = (prod.variants[0] && prod.variants[0].image) ? prod.variants[0].image : prod.image;
        img.alt = prod.title;

        var pinfo = document.createElement('div');
        pinfo.className = 'gwp-pinfo';

        var pname = document.createElement('div');
        pname.className = 'gwp-pname';
        pname.textContent = prod.title;

        var pprice = document.createElement('div');
        pprice.className = 'gwp-pprice';
        pprice.innerHTML = 'Free <s style="color:rgba(255,255,255,.45);font-weight:400;margin-left:3px;">$' + prod.price + '</s>';

        var isPicked = (currentGift.ti === ti && currentGift.pi === pi);
        if (isPicked) card.classList.add('picked');

        var pchev = document.createElement('div');
        pchev.className = 'gwp-pchev';
        pchev.innerHTML = isPicked ? '<span>Selected</span> \u2713' : '<span>Select Gift</span> \u203a';

        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.title = 'View hologram';
        var openHandler = function(e) { e.stopPropagation(); openProductHolo(prod, tier, ti, pi); };
        card.addEventListener('click', openHandler);
        card.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openHandler(e); }
        });

        pinfo.appendChild(pname);
        pinfo.appendChild(pprice);
        card.appendChild(pchk);
        card.appendChild(img);
        card.appendChild(pinfo);
        card.appendChild(pchev);
        tbody.appendChild(card);
      });

      thdr.addEventListener('click', function() {
        if (thdr.classList.contains('locked')) return;
        var isOpen = tbody.classList.contains('open');
        document.querySelectorAll('.gwp-tbody').forEach(function(b) { b.classList.remove('open'); });
        document.querySelectorAll('.gwp-thdr').forEach(function(h) { h.classList.remove('open'); });
        if (!isOpen) { tbody.classList.add('open'); thdr.classList.add('open'); }
      });

      sec.appendChild(thdr);
      sec.appendChild(tbody);
      modal.appendChild(sec);
    });

    var footer = document.createElement('div');
    footer.id = 'gwp-mfooter';
    var cont = document.createElement('button');
    cont.id = 'gwp-cont';
    cont.disabled = !currentGift.lineKey;
    cont.textContent = currentGift.lineKey ? 'Done \u2014 Close & View Cart' : 'Select a free gift above';
    cont.addEventListener('click', function() {
      if (!currentGift.lineKey) return;
      closePopup();
    });
    footer.appendChild(cont);
    modal.appendChild(footer);
    overlay.appendChild(modal);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closePopup(); });
    document.body.appendChild(overlay);
  }

  function openPopup(qualIdx, subtotal) {
    buildPopup();
    if (window.gwpUpdateShipBar) setTimeout(function(){ window.gwpUpdateShipBar(subtotal); }, 50);
    CONFIG.tiers.forEach(function(tier, ti) {
      var thdr = document.getElementById('gwp-thdr-' + ti);
      var tdot = document.getElementById('gwp-tdot-' + ti);
      var tinfo = document.getElementById('gwp-tinfo-' + ti);
      var tlbl = thdr ? thdr.querySelector('.gwp-tlbl') : null;
      var tbody = document.getElementById('gwp-tbody-' + ti);
      if (!thdr) return;
      if (ti <= qualIdx) {
        thdr.classList.remove('locked');
        thdr.classList.add('clickable');
        if (tlbl) tlbl.classList.add('on');
        if (currentGift.ti === ti) {
          tdot.classList.add('on');
          tinfo.textContent = '1/1 selected';
          tinfo.className = 'gwp-tinfo sel';
        } else {
          tdot.classList.remove('on');
          tinfo.textContent = '';
          tinfo.className = 'gwp-tinfo';
        }
      } else {
        thdr.classList.add('locked');
        thdr.classList.remove('clickable', 'open');
        if (tbody) tbody.classList.remove('open');
        if (tlbl) tlbl.classList.remove('on');
        tdot.classList.remove('on');
        tinfo.textContent = 'Spend $' + Math.ceil(tier.minSubtotal - subtotal) + ' more';
        tinfo.className = 'gwp-tinfo lock';
      }
    });
    var tbody = document.getElementById('gwp-tbody-' + qualIdx);
    var thdr = document.getElementById('gwp-thdr-' + qualIdx);
    if (tbody && !tbody.classList.contains('open')) tbody.classList.add('open');
    if (thdr) thdr.classList.add('open');
    updateContBtn();

var popupFill = document.getElementById('gwp-popup-fill');
var popupMsg = document.getElementById('gwp-popup-msg');
var maxMin2 = CONFIG.tiers[CONFIG.tiers.length - 1].minSubtotal;
var pct2 = Math.min(100, (subtotal / maxMin2) * 100);
if (popupFill) setTimeout(function() { popupFill.style.width = pct2 + '%'; }, 100);
if (window.gwpUpdateShipBar) window.gwpUpdateShipBar(subtotal);

CONFIG.tiers.forEach(function(tier, ti) {
  var dot = document.querySelector('[data-popup-ti="' + ti + '"] .gwp-mile-dot');
  var lbl = document.querySelector('[data-popup-ti="' + ti + '"] div:last-child');
  var reached = subtotal >= tier.minSubtotal;
  if (dot) dot.className = 'gwp-mile-dot' + (reached ? ' reached' : '');
  if (lbl) lbl.style.color = reached ? '#00e5ff' : 'rgba(255,255,255,0.25)';
});

if (popupMsg) {
  if (qualIdx === CONFIG.tiers.length - 1) {
    popupMsg.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" style="vertical-align:middle;margin-right:4px"><path d="M7 1L2 3v4c0 2.8 2.2 5 5 5s5-2.2 5-5V3L7 1z" stroke="#00dcff" stroke-width="1.2" fill="rgba(0,220,255,0.15)"/><path d="M4.5 7l1.8 1.8L9.5 5.5" stroke="#00dcff" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg> You qualify for <span style="color:#00e5ff">1 free gift!</span> Claim yours now.';
  } else {
    var next3 = CONFIG.tiers[qualIdx !== null ? qualIdx + 1 : 0];
    var needed3 = Math.ceil(next3.minSubtotal - subtotal);
    popupMsg.innerHTML = qualIdx !== null
      ? 'You\'re <span style="color:#00e5ff">$' + needed3 + ' away</span> from a <span style="color:#00e5ff">' + next3.label + '</span> — select your free gift below!'
      : 'Spend <span style="color:#00e5ff">$' + needed3 + '</span> more to unlock your free gift!';
  }
}

overlay.classList.add('open');
document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateContBtn() {
    var cont = document.getElementById('gwp-cont');
    if (!cont) return;
    cont.disabled = !currentGift.lineKey;
    cont.textContent = currentGift.lineKey ? 'Done \u2014 Close & View Cart' : 'Select a free gift above';
  }

  /* ============================================================
     PRODUCT HOLOGRAM (matches collection-page hologram look)
  ============================================================ */

  function ensureHoloStyles() {
    if (document.getElementById('gwp-holo-style')) return;
    var s = document.createElement('style');
    s.id = 'gwp-holo-style';
    s.textContent = [
      '#gwp-holo-overlay{position:fixed;inset:0;z-index:2147483647;display:none;align-items:center;justify-content:center;background:radial-gradient(ellipse at center,rgba(16,246,246,.08) 0%,rgba(10,15,25,.94) 70%);backdrop-filter:blur(8px);opacity:0;transition:opacity .3s ease;padding:40px 20px;font-family:"Space Mono",ui-monospace,Menlo,monospace;}',
      '#gwp-holo-overlay.active{display:flex;opacity:1;}',
      '.gwp-holo-stage{position:relative;width:min(900px,92vw);height:min(640px,82vh);transform-style:preserve-3d;perspective:1500px;}',
      '.gwp-holo-window{position:absolute;inset:0;background:linear-gradient(135deg,rgba(16,246,246,.04) 0%,rgba(16,246,246,.12) 50%,rgba(16,246,246,.04) 100%),rgba(10,20,35,.85);border:1px solid #10F6F6;clip-path:polygon(20px 0,100% 0,100% calc(100% - 20px),calc(100% - 20px) 100%,0 100%,0 20px);box-shadow:0 0 40px rgba(16,246,246,.5),0 0 80px rgba(16,246,246,.3),inset 0 0 60px rgba(16,246,246,.1);overflow:hidden;display:flex;flex-direction:column;opacity:0;}',
      '#gwp-holo-overlay.active .gwp-holo-window{animation:gwp-holo-in .5s cubic-bezier(.2,.8,.2,1) 1.25s forwards,gwp-holo-flicker .15s steps(2) infinite 1.75s;}',
      '@keyframes gwp-holo-in{0%{opacity:0;transform:scaleY(.05);filter:brightness(3) blur(4px);}40%{opacity:1;transform:scaleY(.1);filter:brightness(2) blur(2px);}100%{opacity:1;transform:scaleY(1);filter:brightness(1) blur(0);}}',
      '@keyframes gwp-holo-flicker{0%{opacity:1}50%{opacity:.97}100%{opacity:1}}',
      '.gwp-holo-window::before{content:"";position:absolute;inset:0;pointer-events:none;z-index:20;background:repeating-linear-gradient(0deg,rgba(16,246,246,0) 0,rgba(16,246,246,.05) 1px,rgba(16,246,246,0) 3px);animation:gwp-scan-drift 4s linear infinite;}',
      '@keyframes gwp-scan-drift{0%{background-position:0 0}100%{background-position:0 40px}}',
      '.gwp-holo-window::after{content:"";position:absolute;left:0;right:0;height:60px;pointer-events:none;z-index:21;background:linear-gradient(180deg,transparent 0%,rgba(16,246,246,.08) 70%,rgba(16,246,246,.25) 97%,transparent 100%);animation:gwp-scan-sweep 4s linear infinite;}',
      '@keyframes gwp-scan-sweep{0%{top:-60px}100%{top:100%}}',
      '.gwp-holo-brackets{position:absolute;inset:-20px;pointer-events:none;z-index:30;}',
      '.gwp-holo-brackets span{position:absolute;width:40px;height:40px;border:2px solid #10F6F6;filter:drop-shadow(0 0 6px #10F6F6);opacity:0;}',
      '.gwp-holo-brackets span:nth-child(1){top:0;left:0;border-right:none;border-bottom:none;}',
      '.gwp-holo-brackets span:nth-child(2){top:0;right:0;border-left:none;border-bottom:none;}',
      '.gwp-holo-brackets span:nth-child(3){bottom:0;left:0;border-right:none;border-top:none;}',
      '.gwp-holo-brackets span:nth-child(4){bottom:0;right:0;border-left:none;border-top:none;}',
      '#gwp-holo-overlay.active .gwp-holo-brackets span{animation:gwp-bracket-in .4s ease-out forwards;}',
      '#gwp-holo-overlay.active .gwp-holo-brackets span:nth-child(1){animation-delay:1.4s;}',
      '#gwp-holo-overlay.active .gwp-holo-brackets span:nth-child(2){animation-delay:1.5s;}',
      '#gwp-holo-overlay.active .gwp-holo-brackets span:nth-child(3){animation-delay:1.6s;}',
      '#gwp-holo-overlay.active .gwp-holo-brackets span:nth-child(4){animation-delay:1.7s;}',
      '@keyframes gwp-bracket-in{to{opacity:1}}',
      '.gwp-holo-base{position:absolute;left:50%;bottom:-138px;transform:translateX(-50%) translateY(60px);width:70%;max-width:700px;height:22px;background:linear-gradient(180deg,#4a5a75 0%,#1a2333 100%);border:1px solid #6a7a95;box-shadow:0 8px 20px rgba(0,0,0,.7),inset 0 1px 0 rgba(255,255,255,.2);border-radius:2px;opacity:0;}',
      '#gwp-holo-overlay.active .gwp-holo-base{animation:gwp-base-rise .35s cubic-bezier(.2,.8,.2,1) forwards;}',
      '@keyframes gwp-base-rise{0%{opacity:0;transform:translateX(-50%) translateY(60px);}100%{opacity:1;transform:translateX(-50%) translateY(0);}}',
      '.gwp-holo-base::before{content:"";position:absolute;top:-3px;left:50%;transform:translateX(-50%);width:40%;height:3px;background:#10F6F6;box-shadow:0 0 8px #10F6F6,0 0 16px rgba(16,246,246,.5);opacity:0;}',
      '#gwp-holo-overlay.active .gwp-holo-base::before{animation:gwp-base-flicker .45s steps(6,end) .3s forwards,gwp-base-glow 1.5s ease-in-out .75s infinite;}',
      '@keyframes gwp-base-flicker{0%{opacity:0}15%{opacity:.9}25%{opacity:0}40%{opacity:1}55%{opacity:.2}70%{opacity:1}85%{opacity:.6}100%{opacity:1}}',
      '@keyframes gwp-base-glow{0%,100%{opacity:.75;filter:brightness(1)}50%{opacity:1;filter:brightness(1.3)}}',
      '.gwp-holo-beam{position:absolute;left:50%;bottom:-120px;width:60%;height:120px;pointer-events:none;background:linear-gradient(0deg,rgba(16,246,246,.5) 0%,rgba(16,246,246,.2) 30%,rgba(16,246,246,.05) 70%,transparent 100%);clip-path:polygon(10% 100%,90% 100%,70% 0,30% 0);filter:blur(6px);transform:translateX(-50%) scaleX(.05) scaleY(0);transform-origin:bottom center;opacity:0;}',
      '#gwp-holo-overlay.active .gwp-holo-beam{animation:gwp-beam-warmup .55s cubic-bezier(.25,.8,.3,1) .75s forwards,gwp-beam-flicker .25s steps(3) 1.3s infinite;}',
      '@keyframes gwp-beam-warmup{0%{opacity:0;transform:translateX(-50%) scaleX(.05) scaleY(0);}20%{opacity:.9;transform:translateX(-50%) scaleX(.08) scaleY(.3);filter:blur(2px) brightness(2);}55%{opacity:1;transform:translateX(-50%) scaleX(.4) scaleY(.85);filter:blur(4px) brightness(1.5);}100%{opacity:1;transform:translateX(-50%) scaleX(1) scaleY(1);filter:blur(6px) brightness(1);}}',
      '@keyframes gwp-beam-flicker{0%{opacity:.75}50%{opacity:1}100%{opacity:.75}}',
      '.gwp-holo-header{position:relative;z-index:22;display:flex;justify-content:space-between;align-items:center;padding:14px 56px 14px 24px;border-bottom:1px solid rgba(16,246,246,.3);background:rgba(16,246,246,.06);flex-shrink:0;}',
      '.gwp-holo-header .id{font-size:10px;letter-spacing:.2em;color:#10F6F6;font-weight:700;}',
      '.gwp-holo-header .status{display:flex;align-items:center;gap:8px;font-size:10px;letter-spacing:.2em;color:#e8eef5;}',
      '.gwp-holo-header .status::before{content:"";width:8px;height:8px;border-radius:50%;background:#10F6F6;box-shadow:0 0 8px #10F6F6;animation:gwp-status-pulse 1s ease-in-out infinite;}',
      '@keyframes gwp-status-pulse{0%,100%{opacity:.5}50%{opacity:1}}',
      '.gwp-holo-body{position:relative;z-index:22;flex:1;display:grid;grid-template-columns:1fr 1.2fr;grid-template-rows:minmax(0,1fr);gap:20px;padding:24px;min-height:0;overflow:hidden;}',
      '.gwp-holo-product-area{position:relative;min-width:0;padding:14px;background:linear-gradient(135deg,#2a3548 0%,#0f1824 50%,#2a3548 100%);clip-path:polygon(20px 0,calc(100% - 20px) 0,100% 20px,100% calc(100% - 20px),calc(100% - 20px) 100%,20px 100%,0 calc(100% - 20px),0 20px);display:flex;align-items:center;justify-content:center;}',
      '.gwp-holo-product-area::before{content:"";position:absolute;inset:4px;background:linear-gradient(135deg,#0f1824 0%,#2a3548 50%,#0f1824 100%);clip-path:polygon(18px 0,calc(100% - 18px) 0,100% 18px,100% calc(100% - 18px),calc(100% - 18px) 100%,18px 100%,0 calc(100% - 18px),0 18px);z-index:1;}',
      '.gwp-holo-inner-tile{position:relative;z-index:2;width:100%;height:100%;background:radial-gradient(ellipse at center,rgba(16,246,246,.14) 0%,transparent 70%);display:flex;align-items:center;justify-content:center;box-shadow:inset 0 0 0 1px rgba(16,246,246,.4),inset 0 0 20px rgba(0,0,0,.6);clip-path:polygon(12px 0,calc(100% - 12px) 0,100% 12px,100% calc(100% - 12px),calc(100% - 12px) 100%,12px 100%,0 calc(100% - 12px),0 12px);overflow:hidden;}',
      '.gwp-holo-inner-tile::before{content:"";position:absolute;inset:0;background-image:linear-gradient(rgba(16,246,246,.08) 1px,transparent 1px),linear-gradient(90deg,rgba(16,246,246,.08) 1px,transparent 1px);background-size:30px 30px;pointer-events:none;}',
      '.gwp-holo-product{position:relative;z-index:3;width:90%;height:90%;display:flex;align-items:center;justify-content:center;padding:4%;}',
      '.gwp-holo-product img{max-width:100%;max-height:100%;object-fit:contain;filter:drop-shadow(0 0 12px #10F6F6) drop-shadow(0 0 30px rgba(16,246,246,.5));}',
      '.gwp-holo-right{display:flex;flex-direction:column;min-width:0;min-height:0;height:100%;gap:12px;}',
      '.gwp-holo-details{display:flex;flex-direction:column;gap:14px;flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;padding-right:8px;color:#e8eef5;}',
      '.gwp-holo-details::-webkit-scrollbar{width:8px;}',
      '.gwp-holo-details::-webkit-scrollbar-track{background:rgba(16,246,246,.08);}',
      '.gwp-holo-details::-webkit-scrollbar-thumb{background:#10F6F6;border-radius:4px;}',
      '.gwp-holo-eyebrow{font-size:10px;letter-spacing:.25em;color:#10F6F6;font-weight:700;}',
      '.gwp-holo-title{font-size:20px;font-weight:700;letter-spacing:.08em;color:#fff;text-shadow:0 0 12px rgba(16,246,246,.8);line-height:1.2;text-transform:uppercase;margin-top:4px;}',
      '.gwp-holo-price{display:flex;align-items:baseline;gap:12px;padding:10px 0;border-top:1px solid rgba(16,246,246,.2);border-bottom:1px solid rgba(16,246,246,.2);}',
      '.gwp-holo-price .amount{font-size:22px;color:#10F6F6;font-weight:700;}',
      '.gwp-holo-price .compare{font-size:13px;color:rgba(255,255,255,.4);text-decoration:line-through;}',
      '.gwp-holo-price .save{font-size:10px;color:#ff6b9d;letter-spacing:.15em;margin-left:auto;font-weight:700;}',
      '.gwp-holo-desc{font-size:12px;line-height:1.65;color:rgba(232,238,245,.78);letter-spacing:.02em;}',
      '.gwp-holo-desc strong{color:#10F6F6;font-weight:700;}',
      '.gwp-spec-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px 16px;font-size:11px;}',
      '.gwp-spec-grid .k{opacity:.55;letter-spacing:.08em;}',
      '.gwp-spec-grid .v{color:#10F6F6;font-weight:700;text-align:right;}',
      '.gwp-holo-section{position:relative;z-index:23;border:1px solid rgba(16,246,246,.2);background:rgba(16,246,246,.04);padding:12px 14px;clip-path:polygon(8px 0,100% 0,100% calc(100% - 8px),calc(100% - 8px) 100%,0 100%,0 8px);}',
      '.gwp-holo-section h4{font-size:10px;letter-spacing:.22em;color:#10F6F6;font-weight:700;text-transform:uppercase;margin:0 0 8px;display:flex;align-items:center;gap:8px;}',
      '.gwp-holo-section h4::before{content:"";width:12px;height:1px;background:#10F6F6;box-shadow:0 0 4px #10F6F6;}',
      '.gwp-holo-pills{display:flex;gap:6px;flex-wrap:wrap;}',
      '.gwp-holo-pills span{padding:6px 12px;border:1px solid rgba(16,246,246,.4);font-size:11px;letter-spacing:.15em;font-weight:700;color:#e8eef5;clip-path:polygon(4px 0,100% 0,calc(100% - 4px) 100%,0 100%);background:rgba(16,246,246,.05);cursor:pointer;transition:all .15s;}',
      '.gwp-holo-pills span:hover{background:rgba(16,246,246,.18);}',
      '.gwp-holo-pills span.active{background:#10F6F6;color:#0a0f1a;border-color:#10F6F6;box-shadow:0 0 12px rgba(16,246,246,.55);}',
      '.gwp-holo-swatches{display:flex;gap:10px;flex-wrap:wrap;align-items:center;}',
      '.gwp-holo-swatches .sw{width:26px;height:26px;border-radius:50%;border:2px solid rgba(255,255,255,.2);box-sizing:border-box;cursor:pointer;transition:transform .15s,box-shadow .15s;}',
      '.gwp-holo-swatches .sw:hover{transform:scale(1.15);}',
      '.gwp-holo-cta-row{position:relative;z-index:22;display:flex;gap:10px;flex-shrink:0;}',
      '.gwp-holo-add,.gwp-holo-rem{flex:1;padding:14px 18px;font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.18em;text-transform:uppercase;cursor:pointer;clip-path:polygon(10px 0,100% 0,100% calc(100% - 10px),calc(100% - 10px) 100%,0 100%,0 10px);transition:all .2s;}',
      '.gwp-holo-add{background:#10F6F6;color:#0a0f1a;border:none;box-shadow:0 0 18px rgba(16,246,246,.55),0 0 40px rgba(16,246,246,.2);}',
      '.gwp-holo-add:hover{background:#fff;box-shadow:0 0 28px rgba(16,246,246,.85),0 0 60px rgba(16,246,246,.35);}',
      '.gwp-holo-add:disabled{background:#1a2535;color:rgba(255,255,255,.45);cursor:not-allowed;box-shadow:none;}',
      '.gwp-holo-rem{background:transparent;color:#ff6b6b;border:1.5px solid #ff6b6b;box-shadow:0 0 8px rgba(255,107,107,.25);}',
      '.gwp-holo-rem:hover{background:#ff6b6b;color:#fff;box-shadow:0 0 18px rgba(255,107,107,.5);}',
      '.gwp-holo-footer{position:relative;z-index:22;display:flex;justify-content:space-between;padding:10px 24px;border-top:1px solid rgba(16,246,246,.2);font-size:9px;letter-spacing:.2em;color:rgba(16,246,246,.5);flex-shrink:0;}',
      '.gwp-holo-close{position:absolute;top:12px;right:12px;z-index:40;width:32px;height:32px;background:rgba(16,246,246,.1);border:1px solid #10F6F6;color:#10F6F6;cursor:pointer;font-size:16px;clip-path:polygon(6px 0,100% 0,100% calc(100% - 6px),calc(100% - 6px) 100%,0 100%,0 6px);transition:background .2s;line-height:1;padding:0;font-family:inherit;}',
      '.gwp-holo-close:hover{background:rgba(16,246,246,.3);color:#fff;}',
      '@media(max-width:820px){',
      '  #gwp-holo-overlay{padding:12px;}',
      '  .gwp-holo-stage{width:100%;max-width:560px;height:min(720px,calc(100vh - 24px));height:min(720px,calc(100dvh - 24px));}',
      '  .gwp-holo-body{grid-template-columns:1fr;grid-template-rows:200px minmax(0,1fr);gap:12px;padding:14px;}',
      '  .gwp-holo-header{padding:10px 50px 10px 14px;}',
      '  .gwp-holo-header .id,.gwp-holo-header .status{font-size:9px;letter-spacing:.15em;}',
      '  .gwp-holo-title{font-size:16px;letter-spacing:.05em;}',
      '  .gwp-holo-eyebrow{font-size:9px;}',
      '  .gwp-holo-price .amount{font-size:20px;}',
      '  .gwp-holo-section{padding:10px 12px;}',
      '  .gwp-holo-pills span{padding:5px 10px;font-size:10px;}',
      '  .gwp-holo-add,.gwp-holo-rem{padding:12px 14px;font-size:11px;letter-spacing:.12em;}',
      '  .gwp-holo-footer{padding:8px 14px;font-size:8px;letter-spacing:.15em;}',
      '  .gwp-holo-base,.gwp-holo-beam{display:none;}',
      '  .gwp-holo-brackets{inset:-12px;}',
      '  .gwp-holo-brackets span{width:28px;height:28px;}',
      '}',
      '@media(max-width:480px){',
      '  .gwp-holo-body{grid-template-rows:170px minmax(0,1fr);padding:12px;gap:10px;}',
      '  .gwp-holo-title{font-size:15px;}',
      '  .gwp-holo-footer span:nth-child(2){display:none;}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  function openProductHolo(prod, tier, ti, pi) {
    ensureHoloStyles();
    var existing = document.getElementById('gwp-holo-overlay');
    if (existing) existing.remove();

    var sizes = [], colors = [];
    prod.variants.forEach(function(v) {
      var parts = (v.label || '').split(' / ');
      var sz = parts[0];
      var cl = parts.length === 3 ? parts[2] : parts[1];
      if (sz && sizes.indexOf(sz) === -1) sizes.push(sz);
      if (cl && colors.indexOf(cl) === -1) colors.push(cl);
    });
    var COLOR_MAP = {'Carbon Black':'#1a1a1a','Glitch Grey':'#6b6b6b','Slate Grey':'#708090','Wistful White':'#f0f0f0','Cosmic Cream':'#f5e6c8','Techno Tan':'#c4a882','Beautiful Blue':'#4a90d9','Bionic Burgundy':'#6d2b3d','Plasma Pink':'#e8619a','Galactic Green':'#3a9a5c','Black':'#111','RFID':'#10F6F6'};
    var eyebrowText = (tier && tier.label ? tier.label.replace(/^Free\s*/i, '').replace(/\s*\(.+\)\s*$/, '') : 'Faraday Gift') + ' // Free Reward';
    var safeTitle = (prod.title || '').replace(/"/g, '&quot;');

    var selSize = sizes[0] || '';
    var selColor = colors[0] || '';
    var resolvedVariant = prod.variants[0];

    function findVariant(size, color) {
      var match = prod.variants.find(function(v) {
        var p = (v.label || '').split(' / ');
        var vs = p[0];
        var vc = p.length === 3 ? p[2] : p[1];
        if (size && color) return vs === size && vc === color;
        if (size) return vs === size;
        if (color) return vc === color;
        return false;
      });
      if (match) return match;
      match = prod.variants.find(function(v) {
        var p = (v.label || '').split(' / ');
        return p[0] === size;
      });
      return match || prod.variants[0];
    }

    var sizesHtml = sizes.length
      ? sizes.map(function(s) { return '<span data-size="' + s.replace(/"/g, '&quot;') + '"' + (s === selSize ? ' class="active"' : '') + '>' + s + '</span>'; }).join('')
      : '<span class="active">One Size</span>';

    var swatchesHtml = colors.length
      ? colors.map(function(c) {
          var safe = c.replace(/"/g, '&quot;');
          return '<div class="sw" data-color="' + safe + '" title="' + safe + '" style="background:' + (COLOR_MAP[c] || '#555') + ';' + (c === selColor ? 'border-color:#10F6F6;box-shadow:0 0 10px rgba(16,246,246,.6);' : '') + '"></div>';
        }).join('')
      : '';

    var initImgSrc = (prod.variants[0] && prod.variants[0].image) ? prod.variants[0].image : prod.image;
    var isCurrent = currentGift.ti === ti && currentGift.pi === pi;

    var ov = document.createElement('div');
    ov.id = 'gwp-holo-overlay';
    ov.innerHTML =
      '<div class="gwp-holo-stage">'
        + '<div class="gwp-holo-brackets"><span></span><span></span><span></span><span></span></div>'
        + '<div class="gwp-holo-window">'
          + '<button type="button" class="gwp-holo-close" aria-label="Close">\u2715</button>'
          + '<div class="gwp-holo-header">'
            + '<div class="id">\u25b8 PROTECK\u2019D SPEC-LINK // FREE GIFT</div>'
            + '<div class="status">SIGNAL LOCKED</div>'
          + '</div>'
          + '<div class="gwp-holo-body">'
            + '<div class="gwp-holo-product-area"><div class="gwp-holo-inner-tile"><div class="gwp-holo-product"><img src="' + initImgSrc + '" alt="' + safeTitle + '"></div></div></div>'
            + '<div class="gwp-holo-right">'
              + '<div class="gwp-holo-details">'
                + '<div>'
                  + '<div class="gwp-holo-eyebrow">' + eyebrowText.toUpperCase() + '</div>'
                  + '<div class="gwp-holo-title">' + prod.title + '</div>'
                + '</div>'
                + '<div class="gwp-holo-price"><span class="amount">FREE</span><span class="compare">$' + prod.price + '</span><span class="save">SAVE 100%</span></div>'
                + '<div class="gwp-holo-desc">Silver-lined Faraday shielding engineered to block EMF and RF frequencies. Yours free at this gift tier with code <strong>' + DISCOUNT + '</strong>.</div>'
                + '<div class="gwp-holo-section"><h4>Select Size</h4><div class="gwp-holo-pills">' + sizesHtml + '</div></div>'
                + (swatchesHtml ? '<div class="gwp-holo-section"><h4>Select Color</h4><div class="gwp-holo-swatches">' + swatchesHtml + '</div></div>' : '')
                + '<div class="gwp-holo-section"><h4>Specifications</h4><div class="gwp-spec-grid">'
                  + '<div class="k">RETAIL</div><div class="v">$' + prod.price + '</div>'
                  + '<div class="k">YOUR PRICE</div><div class="v">FREE</div>'
                  + '<div class="k">SHIELDING</div><div class="v">Ag-LINED</div>'
                + '</div></div>'
              + '</div>'
              + '<div class="gwp-holo-cta-row">'
                + '<button type="button" class="gwp-holo-add"' + (isCurrent ? ' style="display:none;"' : '') + '>\u25b8 Add as Free Gift</button>'
                + '<button type="button" class="gwp-holo-rem"' + (!isCurrent ? ' style="display:none;"' : '') + '>\u2715 Remove Gift</button>'
              + '</div>'
            + '</div>'
          + '</div>'
          + '<div class="gwp-holo-footer"><span>\u25b8 FREQ 2.4 GHZ</span><span>\u25b8 RENDER @ 60HZ</span><span>\u25b8 GIFT TIER</span></div>'
        + '</div>'
        + '<div class="gwp-holo-beam"></div>'
        + '<div class="gwp-holo-base"></div>'
      + '</div>';

    document.body.appendChild(ov);
    requestAnimationFrame(function() { ov.classList.add('active'); });

    var imgEl = ov.querySelector('.gwp-holo-product img');
    var sizePillEls = ov.querySelectorAll('.gwp-holo-pills span[data-size]');
    var swatchEls = ov.querySelectorAll('.gwp-holo-swatches .sw');
    var addBtn = ov.querySelector('.gwp-holo-add');
    var remBtn = ov.querySelector('.gwp-holo-rem');

    function applyResolved() {
      resolvedVariant = findVariant(selSize, selColor);
      if (resolvedVariant && resolvedVariant.image) imgEl.src = resolvedVariant.image;
      sizePillEls.forEach(function(el) {
        el.classList.toggle('active', el.getAttribute('data-size') === selSize);
      });
      swatchEls.forEach(function(el) {
        var on = el.getAttribute('data-color') === selColor;
        el.style.borderColor = on ? '#10F6F6' : 'rgba(255,255,255,.2)';
        el.style.boxShadow = on ? '0 0 10px rgba(16,246,246,.6)' : 'none';
      });
    }
    applyResolved();

    sizePillEls.forEach(function(el) {
      el.addEventListener('click', function() { selSize = el.getAttribute('data-size'); applyResolved(); });
    });
    swatchEls.forEach(function(el) {
      el.addEventListener('click', function() { selColor = el.getAttribute('data-color'); applyResolved(); });
    });

    addBtn.addEventListener('click', function() {
      var popupCard = document.getElementById('gwp-prod-' + ti + '-' + pi) || document.createElement('div');
      addGift(ti, pi, parseInt(resolvedVariant.id), prod, addBtn, remBtn, popupCard);
    });
    remBtn.addEventListener('click', function() {
      var popupCard = document.getElementById('gwp-prod-' + ti + '-' + pi) || document.createElement('div');
      removeGift(remBtn, addBtn, popupCard);
    });

    var closeHolo = function() {
      ov.remove();
      document.removeEventListener('keydown', escHandler);
    };
    var escHandler = function(e) { if (e.key === 'Escape') closeHolo(); };
    ov.querySelector('.gwp-holo-close').addEventListener('click', function(e) { e.stopPropagation(); closeHolo(); });
    ov.addEventListener('click', function(e) { if (e.target === ov) closeHolo(); });
    document.addEventListener('keydown', escHandler);
  }

  /* ============================================================
     CART ACTIONS
  ============================================================ */

  function addGift(ti, pi, variantId, prod, addBtn, remBtn, card) {
    addBtn.textContent = '...';
    addBtn.disabled = true;

    var doAdd = function() {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { _gwp: 'true', _gwp_tier: String(ti) } })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status && item.status !== 200) throw new Error(item.description);
        currentGift = { ti: ti, pi: pi, variantId: variantId, lineKey: item.key };
        saveGift(currentGift);
        card.classList.add('picked');
        addBtn.style.display = 'none';
        remBtn.style.display = 'inline-block';
        addBtn.textContent = 'ADD';
        addBtn.disabled = false;
        var dot = document.getElementById('gwp-tdot-' + ti);
        var info = document.getElementById('gwp-tinfo-' + ti);
        if (dot) dot.classList.add('on');
        if (info) { info.textContent = '1/1 selected'; info.className = 'gwp-tinfo sel'; }
        updateContBtn();
        setTimeout(function() {
          window.location.href = '/discount/' + encodeURIComponent(DISCOUNT) + '?redirect=/cart';
        }, 600);
      })
      .catch(function(err) {
        console.error('GWP add error:', err);
        addBtn.textContent = 'ADD';
        addBtn.disabled = false;
      });
    };

    if (currentGift.lineKey) {
      var pti = currentGift.ti, ppi = currentGift.pi, pkey = currentGift.lineKey;
      currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
      clearGift();
      var prevCard = document.getElementById('gwp-prod-' + pti + '-' + ppi);
      if (prevCard) {
        prevCard.classList.remove('picked');
        var pa = prevCard.querySelector('.gwp-add');
        var pr = prevCard.querySelector('.gwp-rem');
        if (pa) { pa.style.display = 'inline-block'; pa.textContent = 'ADD'; }
        if (pr) pr.style.display = 'none';
      }
      var pd = document.getElementById('gwp-tdot-' + pti);
      var pi2 = document.getElementById('gwp-tinfo-' + pti);
      if (pd) pd.classList.remove('on');
      if (pi2) { pi2.textContent = ''; pi2.className = 'gwp-tinfo'; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: pkey, quantity: 0 })
      }).then(doAdd).catch(doAdd);
    } else {
      doAdd();
    }
  }

  function removeGift(remBtn, addBtn, card) {
    if (!currentGift.lineKey) return;
    remBtn.textContent = '...';
    remBtn.disabled = true;
    var pti = currentGift.ti;
    var keyToRemove = currentGift.lineKey;
    currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
    clearGift();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: keyToRemove, quantity: 0 })
    }).then(function() {
      card.classList.remove('picked');
      remBtn.style.display = 'none';
      addBtn.style.display = 'inline-block';
      remBtn.textContent = 'REMOVE';
      remBtn.disabled = false;
      var dot = document.getElementById('gwp-tdot-' + pti);
      var info = document.getElementById('gwp-tinfo-' + pti);
      if (dot) dot.classList.remove('on');
      if (info) { info.textContent = ''; info.className = 'gwp-tinfo'; }
      updateContBtn();
      updateBar(lastSubtotal);
    });
  }

  /* ============================================================
     CART WATCHER
  ============================================================ */

  function startCartWatcher() {
    if (watcherRunning) return;
    watcherRunning = true;

    var watcherPaused = false;
    document.addEventListener('click', function(e) {
      if (!e.target || !e.target.classList) return;
      if (e.target.classList.contains('js-qty__adjust')) {
        watcherPaused = true;
        setTimeout(function() { watcherPaused = false; }, 3000);
      }

      if (e.target.classList.contains('js-qty__adjust--minus') && currentGift.lineKey) {
        var clickedWrapper = e.target.closest('.js-qty__wrapper') || e.target.parentElement;
        var itemPrice = 0;
        if (clickedWrapper) {
          var input = clickedWrapper.querySelector('.js-qty__num');
          var cartItem = clickedWrapper.closest('.cart__item');
          var priceEl = cartItem ? cartItem.querySelector('.cart__price') : null;
          if (input && priceEl) {
            var qty = parseInt(input.value) || 1;
            var lineTotal = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
            itemPrice = qty > 0 ? lineTotal / qty : 0;
          }
        }
        setTimeout(function() { updateBar(lastSubtotal - itemPrice); }, 200);
        setTimeout(function() {
          getCartData(function(cart) {
            if (!cart) return;
            var gwpItem = cart.items.find(function(item) {
              return item.properties && item.properties._gwp === 'true';
            });
            if (!gwpItem) return;
            var ti = parseInt(gwpItem.properties._gwp_tier);
            var tierMin = CONFIG.tiers[ti] ? CONFIG.tiers[ti].minSubtotal : 0;
            var subtotalWithoutGift = (cart.total_price / 100) - (gwpItem.final_line_price / 100);
            if (subtotalWithoutGift < tierMin) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: gwpItem.key, quantity: 0 })
              }).then(function() {
                clearGift();
                currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
                var gwpRow = document.querySelector('[data-key="' + gwpItem.key + '"]');
                if (gwpRow) gwpRow.style.display = 'none';
                window.location.reload();
              });
            }
          });
        }, 400);
      }

      if (e.target.tagName === 'A' && e.target.textContent.trim().toLowerCase() === 'remove' && currentGift.lineKey) {
        var removedLinePrice = 0;
        var cartItemEl = e.target.closest('.cart__item');
        if (cartItemEl) {
          var priceEl = cartItemEl.querySelector('.cart__price');
          if (priceEl) removedLinePrice = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0;
        }
        setTimeout(function() {
          getCartData(function(cart) {
            if (!cart) return;
            var gwpItem = cart.items.find(function(item) {
              return item.properties && item.properties._gwp === 'true';
            });
            if (!gwpItem) return;
            var ti = parseInt(gwpItem.properties._gwp_tier);
            var tierMin = CONFIG.tiers[ti] ? CONFIG.tiers[ti].minSubtotal : 0;
            var subtotalWithoutGift = (cart.total_price / 100) - (gwpItem.final_line_price / 100) - removedLinePrice;
            if (subtotalWithoutGift < tierMin) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: gwpItem.key, quantity: 0 })
              }).then(function() {
                clearGift();
                currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
                var gwpRow = document.querySelector('[data-key="' + gwpItem.key + '"]');
                if (gwpRow) gwpRow.style.display = 'none';
                window.location.reload();
              });
            }
          });
        }, 300);
      }
    });

    var allGiftVariantIds = [];
    CONFIG.tiers.forEach(function(tier) {
      tier.products.forEach(function(prod) {
        prod.variants.forEach(function(v) {
          allGiftVariantIds.push(v.id);
        });
      });
    });

    document.addEventListener('click', function(e) {
      var el = e.target;
      while (el && el !== document.body) {
        if (
          (el.tagName === 'BUTTON' && el.name === 'checkout' && el.classList.contains('cart__checkout')) ||
          (el.tagName === 'INPUT' && el.name === 'checkout') ||
          (el.tagName === 'A' && el.href && el.href.includes('/checkout'))
        ) {
          if (!currentGift.lineKey) return;
          e.preventDefault();
          e.stopPropagation();
          getCartData(function(cart) {
            if (!cart) { window.location.href = '/checkout'; return; }
            var subtotal = cart.total_price / 100;
            var gwpItem = cart.items.find(function(item) {
              return item.properties && item.properties._gwp === 'true';
            });
            if (!gwpItem) { window.location.href = '/checkout'; return; }
            var ti = parseInt(gwpItem.properties._gwp_tier);
            var tierMin = CONFIG.tiers[ti] ? CONFIG.tiers[ti].minSubtotal : 0;
            var subtotalWithoutGift = subtotal - (gwpItem.final_line_price / 100);
            if (subtotalWithoutGift < tierMin) {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: gwpItem.key, quantity: 0 })
              }).then(function() {
                clearGift();
                currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
                window.location.href = '/checkout';
              }).catch(function() { window.location.href = '/checkout'; });
            } else {
              window.location.href = '/checkout';
            }
          });
          return;
        }
        el = el.parentElement;
      }
    }, true);

    setInterval(function() {
      if (watcherBusy || watcherPaused) return;
      watcherBusy = true;

      getCartData(function(cart) {
        if (!cart) { watcherBusy = false; return; }

        var subtotal = cart.total_price / 100;
        if (Math.abs(subtotal - lastSubtotal) > 0.01) {
          updateBar(subtotal);
        }

        var gwpItems = cart.items.filter(function(item) {
          return item.properties && item.properties._gwp === 'true';
        });

        if (currentGift.lineKey && gwpItems.length === 0) {
          clearGift();
          currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
          updateBar(subtotal);
          watcherBusy = false;
          return;
        }

        if (gwpItems.length > 0 && currentGift.lineKey && gwpItems[0].key !== currentGift.lineKey) {
          currentGift.lineKey = gwpItems[0].key;
          saveGift(currentGift);
        }

        var manualGiftItems = cart.items.filter(function(item) {
          return (!item.properties || item.properties._gwp !== 'true') &&
                 allGiftVariantIds.indexOf(item.variant_id) !== -1;
        });

        if (manualGiftItems.length > 0) {
          var removeNext = function(idx) {
            if (idx >= manualGiftItems.length) { watcherBusy = false; return; }
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: manualGiftItems[idx].key, quantity: 0 })
            }).then(function() { removeNext(idx + 1); }).catch(function() { removeNext(idx + 1); });
          };
          removeNext(0);
          return;
        }

        if (gwpItems.length > 1) {
          var sorted = gwpItems.slice().sort(function(a, b) { return b.price - a.price; });
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: sorted[1].key, quantity: 0 })
          }).then(function() { watcherBusy = false; }).catch(function() { watcherBusy = false; });
          return;
        }

        var didMutate = false;
        gwpItems.forEach(function(giftItem) {
          var ti = giftItem.properties._gwp_tier !== undefined ? parseInt(giftItem.properties._gwp_tier) : null;

          if (giftItem.quantity > 1) {
            didMutate = true;
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftItem.key, quantity: 1 })
            }).then(function() { watcherBusy = false; }).catch(function() { watcherBusy = false; });
            return;
          }

          if (ti !== null) {
            var tierMin = CONFIG.tiers[ti].minSubtotal;
            var subtotalWithoutGift = subtotal - (giftItem.final_line_price / 100);
            if (subtotalWithoutGift < tierMin) {
              didMutate = true;
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: giftItem.key, quantity: 0 })
              }).then(function() {
                if (currentGift.lineKey === giftItem.key) {
                  clearGift();
                  currentGift = { ti: null, pi: null, variantId: null, lineKey: null };
                  updateContBtn();
                  var btn = document.getElementById('gwp-claim-btn');
                  if (btn) btn.textContent = 'CLAIM YOUR FREE GIFT';
                }
                var gwpRow = document.querySelector('[data-key="' + giftItem.key + '"]');
                if (gwpRow) gwpRow.style.display = 'none';
                window.location.reload();
                watcherBusy = false;
              }).catch(function() { watcherBusy = false; });
            }
          }
        });

        if (!didMutate) watcherBusy = false;
      });
    }, 1200);
  }

/* ============================================================
     INIT
  ============================================================ */

  function init() {
    var path = window.location.pathname;
    if (path !== '/cart' && path.indexOf('/cart') !== 0) return;

    getCartData(function(cart) {
      if (!cart) return;
      var subtotal = cart.total_price / 100;
      syncGiftFromCart(cart.items);
      buildProgressBar(subtotal);
      startCartWatcher();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();